export default function AboutHero() {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/c6b479d5eb2811b7ae2f728dd8b57e19.jpg"
          alt="Heritage Water Source"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center text-white px-6 max-w-5xl mx-auto">
        <h1 className="text-6xl lg:text-7xl font-light mb-6 tracking-tight">
          Our Story
        </h1>
        <p className="text-xl lg:text-2xl font-light leading-relaxed max-w-3xl mx-auto">
          유네스코 생물권보전지역에서 시작된<br />
          더 나은 물을 향한 여정
        </p>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white"></i>
      </div>
    </section>
  );
}
